export class InitAuthInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "password",
            "baseName": "password",
            "type": "string",
            "format": ""
        },
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InitAuthInput.attributeTypeMap;
    }
    constructor() {
    }
}
